import { render, staticRenderFns } from "./ApproveIdeas.vue?vue&type=template&id=5264f31e&"
import script from "./ApproveIdeas.vue?vue&type=script&lang=js&"
export * from "./ApproveIdeas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports